export const getToken = (string: string, divider: string) => {
  let array = string.split(divider);
  return array[array.length - 1];
};

export const scrollToElement = (id: string) => {
  const target = document.getElementById(id);
  target?.scrollIntoView({behavior: 'smooth'});
};

export const scrollToTop = () => {
  window.scrollTo(0, 0);
};

export const copyLinkToClipboard = (text: string, message: string) => {
  navigator.clipboard.writeText(text).then(() => {
    alert(message + ': ' + text);
  });
};
